/**
 * Copyright (c) 2023, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

/* eslint-disable sort-keys */

import {
  CheckCircleSharp,
  CheckCircleTwoTone,
  ErrorTwoTone,
  HighlightOffTwoTone,
  ScheduleTwoTone
} from "@mui/icons-material";

const operational = "Operational";
const maintenance = "Maintenance";
const degraded = "Degraded";
const outage = "Outage";

const operationalColor = "#388e3c";
const maintenanceColor = "#1976d2";
// const degradedColor = "#ed6c02";
const degradedColor = "#f5a433";
const outageColor = "#d32f2f";

const investigatingColor = "#FF8C00";
const inprogressColor = "#DAA520";
const updateColor = "#0000FF";
const resolvedColor = "#008000";

export default {
  color: {
    Operational: operationalColor,
    Maintenance: maintenanceColor,
    Degraded: degradedColor,
    Outage: outageColor,
    Investigating: investigatingColor,
    "In Progress": inprogressColor,
    Update: updateColor,
    Resolved: resolvedColor
  },
  legends: [
    {
      color: operationalColor,
      icon: CheckCircleTwoTone,
      title: operational
    },
    {
      color: maintenanceColor,
      icon: ScheduleTwoTone,
      title: maintenance
    },
    {
      color: degradedColor,
      icon: ErrorTwoTone,
      title: degraded
    },
    {
      color: outageColor,
      icon: HighlightOffTwoTone,
      title: outage
    }
  ],
  status: {
    0: {
      IconComponent: CheckCircleSharp,
      backgroundColor: operationalColor,
      color: "#ffffff",
      description: "All Services Operational",
      title: operational
    },
    1: {
      IconComponent: ScheduleTwoTone,
      backgroundColor: maintenanceColor,
      color: "#ffffff",
      description: "Service Under Maintenance",
      title: maintenance
    },
    2: {
      IconComponent: ErrorTwoTone,
      backgroundColor: degradedColor,
      color: "#ffffff",
      description: "Experiencing Degraded Service",
      title: degraded
    },
    3: {
      IconComponent: HighlightOffTwoTone,
      backgroundColor: outageColor,
      color: "#ffffff",
      description: "Service Outage",
      title: outage
    }
  },
  statusCode: {
    Operational: 0,
    Maintenance: 1,
    Degraded: 2,
    Outage: 3
  }
};
